export default "__VITE_ASSET__C5bxXl0i__"